module.exports = __webpack_public_path__ + "img/cc-image.9e2db6fd.png";